import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import PublicShell from "../../components/public/PublicShell";
import PublicPortfolio from "./Portfolio";
import { api } from "../../lib/api";
import { BACKEND } from "../../lib/portfolio";

export default function PortfolioProject() {
  const { id } = useParams();
  const [search] = useSearchParams();
  const site = search.get("site") || undefined;
  const [state, setState] = useState({ loading: true, project: null });
  useEffect(() => {
    let live = true;
    api.get("/public/portfolio-status", { params: { site } })
      .then((r) => (r.data.enabled ? api.get(`/public/portfolio/projects/${id}`, { params: { site } }) : null))
      .then((r) => live && setState({ loading: false, project: r ? r.data : null }))
      .catch(() => live && setState({ loading: false, project: null }));
    return () => { live = false; };
  }, [id, site]);
  if (state.loading) return null;
  if (!state.project) return <PublicPortfolio />;
  const p = state.project;
  const hero = (
    <section className="erf-public-hero" style={{ padding: "72px 0 40px" }} data-testid="public-project-hero">
      <div className="erf-public-container">
        <div className="erf-public-hero-eyebrow">{[p.category, p.address_city, p.address_state].filter(Boolean).join(" · ") || "Portfolio"}</div>
        <h1 style={{ maxWidth: 820 }} data-testid="public-project-title">{p.title}</h1>
        {p.summary && <p className="lead">{p.summary}</p>}
      </div>
    </section>
  );
  return (
    <PublicShell hero={hero}>
      <section className="erf-public-section">
        <div className="erf-public-container">
          {p.long_description && <p style={{ maxWidth: 760, whiteSpace: "pre-wrap", marginBottom: 32 }}>{p.long_description}</p>}
          <div style={{ display: "grid", gap: 16, gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 320px), 1fr))" }} data-testid="public-project-gallery">
            {p.media.map((m) => (
              <figure key={m.id} style={{ margin: 0 }} data-testid={`public-project-media-${m.id}`}>
                {m.kind === "video" && m.urls.web ? (
                  <video poster={m.urls.poster ? `${BACKEND}${m.urls.poster}` : undefined} controls preload="metadata"
                    style={{ width: "100%", borderRadius: 8 }} aria-label={m.alt_text || m.caption || "Project video"}
                    data-testid={`public-project-video-${m.id}`}>
                    {m.urls.hls && <source src={`${BACKEND}${m.urls.hls}`} type="application/vnd.apple.mpegurl" />}
                    <source src={`${BACKEND}${m.urls.web}`} type="video/mp4" />
                  </video>
                ) : (
                  <img src={`${BACKEND}${m.urls.web || m.urls.thumb}`} alt={m.alt_text || m.caption || `${p.title} photo`}
                    loading="lazy" style={{ width: "100%", aspectRatio: "4 / 3", objectFit: "cover", borderRadius: 8 }} />
                )}
                {m.caption && <figcaption style={{ marginTop: 6, fontSize: 14 }}>{m.caption}</figcaption>}
              </figure>
            ))}
          </div>
          <div style={{ marginTop: 40 }}>
            <Link to={site ? `/portfolio?site=${site}` : "/portfolio"} className="erf-public-cta-outline" data-testid="public-project-back">All projects</Link>
          </div>
        </div>
      </section>
    </PublicShell>
  );
}
